import React from 'react'
import LinearProgress from '@material-ui/core/LinearProgress'
import ErrorIcon from '@material-ui/icons/Error'
import { useStyles } from '../styles'
import { UploadingPhoto } from '../types'

interface UploadingCardProps {
  photo: UploadingPhoto
  onRetry: (photo: UploadingPhoto) => void
}

export const UploadingCard: React.FC<UploadingCardProps> = ({ photo, onRetry }) => {
  const styles = useStyles()

  return (
    <div className={styles.uploadingCard}>
      <img src={photo.previewUrl} alt={photo.fileName} className={styles.uploadingImage} />

      {photo.status === 'uploading' && (
        <div className={styles.uploadingOverlay}>
          <LinearProgress className={styles.uploadingProgressBar} />
        </div>
      )}

      {photo.status === 'error' && (
        <div className={styles.uploadingErrorOverlay}>
          <ErrorIcon className={styles.uploadingErrorIcon} />
          <span className={styles.uploadingErrorText}>Erro ao enviar</span>
          <button className={styles.uploadingRetryButton} onClick={() => onRetry(photo)}>
            Enviar novamente
          </button>
        </div>
      )}
    </div>
  )
}
